/* Model */
class GeofenceModel extends App.Models.BaseModel {
    modelUrl = 'Geofence';
}

App.Models.Geofence = GeofenceModel;

/* Collection */
class GeofenceCollection extends App.Collections.BaseCollection {
    url = 'Geofence';
    model = App.Models.Geofence;
}

App.Collections.Geofences = GeofenceCollection;
